(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ROADMAP"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var timeline = document.getElementById('roadmap-timeline-{{ section.id }}');
    var barra = document.getElementById('roadmap-progreso-{{ section.id }}');
    if (!timeline || !barra) return;

    var ticking = false;

    function actualizar() {
      var rect = timeline.getBoundingClientRect();
      var total = timeline.offsetHeight;
      var vh = window.innerHeight;

      // El punto de referencia es el centro de la pantalla
      var punto = vh * 0.5;

      // Cuánto ha avanzado el punto de referencia dentro del timeline
      var avanzado = punto - rect.top;

      var altura = Math.max(0, Math.min(avanzado, total));
      barra.style.height = altura + 'px';

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(actualizar);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', actualizar, { passive: true });
    actualizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-carrusel"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciar(id) {
    var pista = document.getElementById('videorese-pista-' + id);
    var contenedorPuntos = document.getElementById('videorese-puntos-' + id);
    if (!pista) return;

    var slides = pista.querySelectorAll('.videorese-slide');
    var puntos = contenedorPuntos ? contenedorPuntos.querySelectorAll('.videorese-punto') : [];
    var total = slides.length;
    var indice = 0;
    var xInicio = 0;
    var tocando = false;
    var arrastrado = false;

    function anchoSlide() {
      if (!slides[0]) return 0;
      return slides[0].offsetWidth + parseInt(getComputedStyle(pista).gap || 0);
    }

    function irA(n) {
      indice = Math.max(0, Math.min(n, total - 1));
      var desplazamiento = indice * anchoSlide();
      pista.style.transform = 'translateX(-' + desplazamiento + 'px)';
      puntos.forEach(function(p, i) {
        p.classList.toggle('videorese-punto--activo', i === indice);
      });
    }

    puntos.forEach(function(p) {
      p.addEventListener('click', function() {
        irA(parseInt(this.getAttribute('data-indice')));
      });
    });

    pista.addEventListener('touchstart', function(e) {
      xInicio = e.touches[0].clientX;
      tocando = true;
      arrastrado = false;
    }, { passive: true });

    pista.addEventListener('touchmove', function(e) {
      if (!tocando) return;
      if (Math.abs(e.touches[0].clientX - xInicio) > 8) arrastrado = true;
    }, { passive: true });

    pista.addEventListener('touchend', function(e) {
      if (!tocando) return;
      var diff = xInicio - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) irA(diff > 0 ? indice + 1 : indice - 1);
      tocando = false;
    }, { passive: true });

    pista.addEventListener('mousedown', function(e) {
      xInicio = e.clientX;
      tocando = true;
      arrastrado = false;
    });

    window.addEventListener('mousemove', function(e) {
      if (!tocando) return;
      if (Math.abs(e.clientX - xInicio) > 8) arrastrado = true;
    });

    window.addEventListener('mouseup', function(e) {
      if (!tocando) return;
      var diff = xInicio - e.clientX;
      if (Math.abs(diff) > 40) irA(diff > 0 ? indice + 1 : indice - 1);
      tocando = false;
    });

    pista.querySelectorAll('.videorese-play-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        if (arrastrado) return;
        var wrap = this.closest('.videorese-media-wrap');
        var video = wrap ? wrap.querySelector('.videorese-video') : null;
        if (!video) return;
        if (video.paused) {
          video.play();
          this.classList.add('videorese-play-btn--oculto');
        } else {
          video.pause();
          this.classList.remove('videorese-play-btn--oculto');
        }
      });
    });

    pista.querySelectorAll('.videorese-video').forEach(function(video) {
      video.addEventListener('ended', function() {
        var wrap = this.closest('.videorese-media-wrap');
        var btn = wrap ? wrap.querySelector('.videorese-play-btn') : null;
        if (btn) btn.classList.remove('videorese-play-btn--oculto');
      });
    });

    window.addEventListener('resize', function() { irA(indice); });
  }

  function iniciarResenas(id) {
    var pista = document.getElementById('videorese-resenas-pista-' + id);
    var btnPrev = document.getElementById('videorese-prev-' + id);
    var btnNext = document.getElementById('videorese-next-' + id);
    if (!pista) return;

    var cards = pista.querySelectorAll('.videorese-resena-card');
    if (!cards.length) return;
    var indice = 0;

    function mostrar(n) {
      indice = (n + cards.length) % cards.length;
      cards.forEach(function(c, i) {
        c.classList.toggle('videorese-resena-card--activa', i === indice);
      });
    }

    mostrar(0);

    if (btnPrev) btnPrev.addEventListener('click', function() { mostrar(indice - 1); });
    if (btnNext) btnNext.addEventListener('click', function() { mostrar(indice + 1); });
  }

  document.addEventListener('DOMContentLoaded', function() {
    iniciar('{{ section.id }}');
    iniciarResenas('{{ section.id }}');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarCarrusel(seccionId) {
    var seccion = document.getElementById('porquefunciona-' + seccionId);
    if (!seccion || seccion.getAttribute('data-modo-movil') !== 'slider') return;

    var pista = document.getElementById('porquefunciona-pista-' + seccionId);
    var contenedorPuntos = document.getElementById('porquefunciona-puntos-' + seccionId);
    if (!pista) return;

    var indiceActual = 0;
    var cards = pista.querySelectorAll('.porquefunciona-card');
    var puntos = contenedorPuntos ? contenedorPuntos.querySelectorAll('.porquefunciona-punto') : [];
    var totalCards = cards.length;
    var xInicio = 0;
    var tocando = false;

    function esMovil() {
      return window.innerWidth < 749;
    }

    function irA(indice) {
      if (!esMovil()) return;
      indiceActual = Math.max(0, Math.min(indice, totalCards - 1));
      pista.style.transform = 'translateX(-' + (indiceActual * 100) + '%)';
      puntos.forEach(function(p, i) {
        p.classList.toggle('porquefunciona-punto--activo', i === indiceActual);
      });
    }

    puntos.forEach(function(punto) {
      punto.addEventListener('click', function() {
        irA(parseInt(this.getAttribute('data-indice')));
      });
    });

    pista.addEventListener('touchstart', function(e) {
      if (!esMovil()) return;
      xInicio = e.touches[0].clientX;
      tocando = true;
    }, { passive: true });

    pista.addEventListener('touchend', function(e) {
      if (!esMovil() || !tocando) return;
      var diff = xInicio - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        irA(diff > 0 ? indiceActual + 1 : indiceActual - 1);
      }
      tocando = false;
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (!esMovil()) {
        pista.style.transform = '';
      } else {
        irA(indiceActual);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    iniciarCarrusel('{{ section.id }}');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
